module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-04.165d8818.jpg";